import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Spinner } from 'react-bootstrap'

import { Backdrop } from './Backdrop'

interface ContextValue {
  count: number
  register: () => () => void
}

const Context = createContext<ContextValue>({
  count: 0,
  register: () => () => {
    /**/
  },
})

export function FullscreenSpinnerProvider(props: Record<string, any>) {
  const [count, setCount] = useState(0)

  const register = useCallback(() => {
    setCount((count) => count + 1)

    return function () {
      setCount((count) => count - 1)
    }
  }, [])

  return (
    <Context.Provider
      {...props}
      value={useMemo(
        () => ({
          count,
          register,
        }),
        [count, register]
      )}
    />
  )
}

export function useFullscreenSpinner(show: boolean) {
  const { register } = useContext(Context)

  useEffect(() => {
    if (show) {
      return register()
    }
    return () => {
      /** */
    }
  }, [register, show])
}

export function FullscreenSpinner() {
  const { count } = useContext(Context)
  if (count > 0) {
    return (
      <Backdrop>
        <Spinner animation="border" />
        <h6 style={{ marginTop: '1rem' }}>Waking up...</h6>
      </Backdrop>
    )
  } else {
    return null
  }
}
